import React, { Component } from 'react';

import Header from './Header';
import Left from './Left';
import Body from './Body';

import Config from '../config/Config';
import Cache from './Cache'

import WidgetAjax from '../widget/WidgetAjax';
import WidgetMessage from './../widget/WidgetMessage';
import './../css/base.css';

import './../css/project.css';

class Frame extends Component {
    constructor(props) {
        super(props);
        this.state = {
            basePath: Config.getBasePath(),
            titleNodes: [
                {name:'homePage',title:"首页",path:"/home/homepage"},
                {name:'recommendedJob',title:"职位",path:"/home/recommendedJob"},
                {name:'enterprise',title:"企业",path:"/home/enterprise"},
                // {name:'Internship',title:"实习",path:"/home/Internship"},
                {name:'partTimeJob',title:"灵活就业",path:"/home/partTimeJob"},
                {name:'careerPlanning',title:"职业规划",path:"/home/career-planning"},
                // {name:'homePage5',title:"关于我们",path:"/home/homepage"}
            ],
            leftNode: [
            ],
            privileges: [
                {name:'homePage',title:"首页",path:"/home/homepage"},
                {name:'ai-chat',title:"AI对话",path:"/home/ai-chat"},
                {name:'recommendedJob',title:"职位",path:"/home/recommendedJob"},
                {name:'jobDetails',title:"职位详情",path:"/home/jobdetails"},
                {name:'enterprise',title:"企业",path:"/home/enterprise"},
                {name:'Internship',title:"实习",path:"/home/Internship"},
                {name:'partTimeJob',title:"灵活就业",path:"/home/partTimeJob"},
                {name:'partTimeSearch',title:"灵活就业",path:"/home/partTimeSearch"},
                {name:'enterprise-detail',title:"企业详情",path:"/home/enterprise/detail"},
                {name:'careerPlanning',title:"职业规划",path:"/home/career-planning"},
                {name:'careerExplore',title:"职业探索",path:"/home/career-explore"},
                {name:'careerExploreAI',title:"职业探索",path:"/home/career-explore-ai"},
                {name:'resume',title:"在线简历",path:"/home/resume"},
                {name:'careerSeek',title:"职业探索",path:"/home/career-seek"},
                {name:'careerEvaluation',title:"职业测评",path:"/home/career-evaluation"},
                {name:'careerEvaluationInfo',title:"职业测评信息",path:"/home/career-evaluation-info"},
                
            ],
            leftNodes: {
                homePage:[
                    {name:'ai-chat',title:"AI对话",path:"/home/ai-chat", type:"POPUP"}
                ],
                enterprise:[
                    {name:'enterprise-detail',title:"企业详情",path:"/home/enterprise/detail", type:"POPUP"}
                ],
                partTimeJob:[
                    {name:'partTimeSearch',title:"灵活就业",path:"/home/partTimeSearch", type:"POPUP"}
                ],
                careerPlanning:[
                    // {name:'profession-detail',title:"职业树详情",path:"/home/profession/detail", type:"POPUP"}
                    {name:'careerExplore',title:"职业探索",path:"/home/career-explore", type:"POPUP"},
                    {name:'careerExploreAI',title:"职业探索",path:"/home/career-explore-ai", type:"POPUP"},
                    {name:'careerSeek',title:"职业探索",path:"/home/career-seek",  type:"POPUP"},
                    {name:'careerEvaluation',title:"职业测评",path:"/home/career-evaluation", type:"POPUP"},
                    {name:'careerEvaluationInfo',title:"职业测评信息",path:"/home/career-evaluation-info", type:"POPUP"},
                    {name:'careerEvaluationTest',title:"职业测评问题",path:"/home/ career-evaluation-test", type:"POPUP"}
                ]
            },
            nodes: undefined,
            systemTitle: "高校毕业生就业服务智能体平台",
            titleActiveKey: "homePage",
            leftActiveKey: '',
            menuPaths: [],
            collapsed: false,
           
        };

        this.leftOnSelect = this.leftOnSelect.bind(this);
        this.headerOnSelect = this.headerOnSelect.bind(this);
        this.freshPage = this.freshPage.bind(this);
        this.redrict = this.redrict.bind(this);

        this.findNode = this.findNode.bind(this);

        this.loadComponent = this.loadComponent.bind(this);
        this.onLoadComponent = this.onLoadComponent.bind(this);
        this.buildNodes = this.buildNodes.bind(this);


        this.myRef = this;
    }

    componentDidMount() {
        
        // this.loadComponent();

        this.findNode(this.props.children.props);
    }

    componentWillReceiveProps( nextProps )
    {
        this.findNode(nextProps.children.props);
    }

    /**
     * 请求用户有权限的组件
     */
    loadComponent() {
        WidgetAjax.ajax({ url: Config.getBasePath() + '/component', params: undefined, callback:this.onLoadComponent });
    }

    /**
     * 请求
     * @param {*} result 
     * @param {*} params 
     */
    onLoadComponent(result, params) 
    {

        if (result.status === 0) 
        {
            if (result.result !== undefined && result.result.frame !== undefined) 
            {
                this.state["nodes"] = result.result.frame;
            }

            if (result.result !== undefined && result.result.privileges !== undefined) 
            {
                this.state["privileges"] = result.result.privileges;
            }

            this.buildNodes(this.state.nodes);
        }
        else 
        {
            sessionStorage.removeItem("_user_access_");
            sessionStorage.removeItem("_user_info_");
            sessionStorage.removeItem("_user_login_info_");

            WidgetMessage.error(result.message);

            this.redrict("/login", undefined, true);
        }
    }

    /**
     * 创建菜单节点
     * @param {*} nodes 
     * @returns 
     */
    buildNodes(nodes) 
    {
        let titleNodes = [], leftNodes = [], titleActiveKey, leftNode = [];

        if (nodes !== undefined && nodes.length > 0) 
        {
            for (let i = 0; i < nodes.length; i++) 
            {
                if (nodes[i].type === "PAGE" || nodes[i].type === "LINK" || nodes[i].type === undefined) 
                {
                    titleNodes.push(nodes[i]);

                    if (leftNodes[nodes[i].name] === undefined) 
                    {
                        leftNodes[nodes[i].name] = [];
                    }

                    if (nodes[i].children !== undefined) 
                    {
                        leftNodes[nodes[i].name].push(...nodes[i].children);
                    }
                  
                        // leftNodes.push(nodes[i]);
                  
                    if (i === 0) 
                    {
                        titleActiveKey = nodes[i].name;
                    }
                }
            }
        }
        if (leftNodes[titleActiveKey] !== undefined) 
        {
            leftNode.push(...leftNodes[titleActiveKey]);
        }
        this.setState({ titleNodes: titleNodes, leftNodes: leftNodes, titleActiveKey: titleActiveKey, leftNode: leftNodes });
    }

    /**
     * 头部菜单选择后回调函数
     * @param {*} key 
     */
    headerOnSelect(key) 
    {
        if (!key) return;

        key = typeof key == 'string' ? key : key.key

        let { titleNodes } = this.state;

        let menuPaths = [];

        let leftNode = this.state.leftNodes[key];

        menuPaths.push(key);

        this.setState({ leftNode: leftNode||[], titleActiveKey: key, menuPaths: menuPaths });

        for (let item of titleNodes) 
        {
            if (item.name === key) 
            {
                let state = {
                    node: item,
                    item: item,
                    children: leftNode || []
                };

                this.redrict(item.path, state, false);
            }
        }
    }

    leftOnSelect(key, path, keyPaths) 
    {
        let { menuPaths, titleNodes, id } = this.state;

        let showHeaderArea = Config.isShowHeaderArea();

        if( showHeaderArea!==true || titleNodes===undefined || titleNodes === null || titleNodes.length === 0) 
        {
            menuPaths = [];
        }

        menuPaths.push(...keyPaths);

        id++;

        this.setState({ leftActiveKey: key, menuPaths: menuPaths });

        this.props.children.props.history.push({ pathname: path, state: { pathData: key } });

    }

    freshPage() 
    {
        window.location.reload(); //刷新页面
    }

    redrict(path, state, isFresh) 
    {
        this.props.children.props.history.push({ pathname: path, state: state });

        if (isFresh !== undefined && isFresh !== false) 
        {
            this.freshPage();
        }
    }

    findNode(nodeProps) 
    {

        const { titleNodes, leftNodes, privileges } = this.state;

        let { titleActiveKey, leftActiveKey } = this.state;

        let path = "", node, item, pathNodes = [];

        if (nodeProps !== undefined && nodeProps.match !== undefined) 
        {
            path = nodeProps.match.path;
        }

        if (nodeProps !== undefined && nodeProps.location !== undefined && nodeProps.location.state !== undefined) 
        {
            item = nodeProps.location.state.node;
        }

        if (path !== undefined && path !== null && path !== "") 
        {
            node = this.findNodeByNodes(privileges, path, item, true);

            if( node !== undefined && node !== null ) 
            {
                let frameNode = this.findNodeByNodes(titleNodes, path, node, false);

                if( frameNode !== undefined && frameNode !== null ) 
                {
                    let leftNode = leftNodes[frameNode.name];

                    this.setState({node:frameNode, leftNode: leftNode||[], titleActiveKey: frameNode.name});

                    return ;
                }

                for( let key in leftNodes ) 
                {
                    frameNode = this.findNodeByNodes(leftNodes[key], path, node, true);

                    if (frameNode !== undefined && frameNode !== null) 
                    {
                        titleActiveKey = key;
                        break;
                    }
                }

                if( frameNode!==undefined && frameNode !== null ) 
                {
                    let leftNode = leftNodes[titleActiveKey];
                    let leftActiveKey = frameNode.name;

                    if (frameNode.type === "POPUP") 
                    {
                        this.findParentMenuNode(leftNode, frameNode, true, pathNodes);

                        if (pathNodes && pathNodes.length > 0) 
                        {
                            for (let item of pathNodes) 
                            {
                                if (item.type !== "POPUP") 
                                {
                                    leftActiveKey = item.name;

                                    break;
                                }
                            }
                        }
                    }

                    this.setState({leftNode:leftNode||[], titleActiveKey:titleActiveKey, leftActiveKey:leftActiveKey});

                }
                else 
                {
                    this.setState({titleActiveKey:undefined, leftActiveKey:node.name});
                }
            }
            else 
            {
                if (!item) return;

                let leftNode = this.state.leftNodes[item.name]

                this.setState({leftNode:leftNode || [], titleActiveKey:item.name});
            }
        }

    }

    /**
     * 通过path查找节点
     * @param {*} nodes 
     * @param {*} item 当前节点 
     * @param {*} isRecurse 是否需要递归查找
     * @returns 
     */
    findParentMenuNode = (nodes, item, isRecurse, pathNodes = []) => {

        let isFind = false;

        if (nodes !== undefined && nodes.length > 0 && item) 
        {
            for (let i = 0; i < nodes.length; i++) 
            {
                if (nodes[i].name !== undefined && item !== undefined && item !== null && nodes[i].name === item.name) 
                {
                    isFind = true;
                }
                else if (nodes[i].children !== undefined && isRecurse === true) 
                {
                    isFind = this.findParentMenuNode(nodes[i].children, item, true, pathNodes);
                }

                if (isFind === true) 
                {
                    pathNodes.push(nodes[i])
                    break;
                }
            }
        }

        return isFind;
    }

    /**
     * 通过path查找节点
     * @param {*} nodes 
     * @param {*} path 
     * @param {*} item 当前节点 
     * @param {*} isRecurse 是否需要递归查找
     * @returns 
     */
    findNodeByNodes(nodes, path, item, isRecurse) 
    {
        let node = null;

        if (nodes !== undefined && nodes.length > 0) 
        {
            for (let i = 0; i < nodes.length; i++) 
            {
                if (item !== undefined && item !== null && item !== "") 
                {
                    if (nodes[i].name !== undefined && item !== undefined && item !== null && nodes[i].name === item.name) 
                    {
                        node = nodes[i];
                    }
                    else if (nodes[i].children !== undefined && isRecurse === true) 
                    {
                        node = this.findNodeByNodes(nodes[i].children, path, item, true);
                    }
                }
                else 
                {
                    if (nodes[i].path !== undefined && (nodes[i].path === path || ("/" + nodes[i].path) === path || ("/" + nodes[i].path + "/") === path || (nodes[i].path + "/") === path)) 
                    {
                        node = nodes[i];
                    }
                    else if (nodes[i].children !== undefined && isRecurse === true) 
                    {
                        node = this.findNodeByNodes(nodes[i].children, path, item, true);
                    }
                }

                if (node !== null) 
                {
                    break;
                }
            }

            return node;
        }
    }



    render() {
        const { titleNodes, systemTitle, menuPaths, collapsed, classComponent } = this.state;

        // this.findNode(this.props.children.props);

        let { leftNode, titleActiveKey, disposalData, leftActiveKey } = this.state;

        // if( leftNode===undefined || leftNode===null || leftNode.length===0 ) 
        // {
        //     return <></>;
        // }

        const { model } = this.props;

        if (model === "home") 
        {
            let state = { children: leftNode };

            if (this.props.children.props.location !== undefined && this.props.children.props.location.state !== undefined) 
            {
                state = { ...this.props.children.props.location.state, ...state };
            }

            this.props.children.props.history.push({ pathname: this.props.children.props.match.path, state: state });
        }

        const childrenBody = React.Children.map(this.props.children, child => React.cloneElement(child, { reload: this.reload }));

        switch (model) {
            case "page":
            {
                return (
                    <div className="sf-page">
                        <Body>{childrenBody}</Body>
                    </div>
                );
            }
            case "table":
            {
                return (
                    <div className="sf-table-page">
                        <Header headerOnSelect={this.headerOnSelect} titleNode={titleNodes} leftNode={leftNode}
                            menuPaths={menuPaths} location={this.props.children.props.location} history={this.props.children.props.history} 
                            systemTitle={systemTitle} activeKey={titleActiveKey} freshPage={this.freshPage} redrict={this.redrict} />
                        <Body>{childrenBody}</Body>
                    </div>
                );
            }
            case "home":
            {
                return (
                    <div className="sf-page">
                        <Body>{childrenBody}</Body>
                    </div>
                );
            }
            default:
            {
                return (
                    <div className="sf-normal">

                        <Header history={this.props} headerOnSelect={this.headerOnSelect} titleNode={titleNodes} leftNode={leftNode} menuPaths={menuPaths} location={this.props.children.props.location}
                            systemTitle={systemTitle} activeKey={titleActiveKey} freshPage={this.freshPage} redrict={this.redrict} />
                        <Left leftNode={leftNode} collapsed={collapsed} disposalData={disposalData} leftActiveKey={leftActiveKey} redrict={this.redrict} leftOnSelect={this.leftOnSelect} history={this.props.children.props.history} location={this.props.children.props.location} />
                        <Body>{childrenBody}</Body>

                    </div>
                );
            }
        }
    }
}

export default Frame